import { render, staticRenderFns } from "./Win.vue?vue&type=template&id=53f5bcd2&scoped=true&"
import script from "./Win.vue?vue&type=script&lang=js&"
export * from "./Win.vue?vue&type=script&lang=js&"
import style0 from "./Win.vue?vue&type=style&index=0&id=53f5bcd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5bcd2",
  null
  
)

export default component.exports